import {Configuration} from './Configuration';
import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {ProcessStepExt} from './ProcessStepExt';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class Flow extends ConnectBasicEntityExt {
description: TranslatedEmb;
label: TranslatedEmb;
params: Configuration;
pid: number | null;
processCode: string;
steps: {[key: string]: ProcessStepExt};
targets: {[key: string]: string};
visionCode: string;
}

